import { ReactElement, useState } from 'react'
import { InputGroup, Link } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { PropsTermsTemplate } from './props'

const TermsTemplate = ({
    partner,
    basisType,
    isAccepted,
    setIsAccepted,
    submitClickedWithMissingDetails,
    isCompanyBooking,
}: PropsTermsTemplate): ReactElement => {
    const { t } = useTranslation()

    const [showError, setShowError] = useState(false)

    const getGDPRLink = (): string => {
        const baseURL = 'https://www.raskrask.dk/privatpolitik/'
        if (partner && basisType) {
            const thisTherapistGDPRID = partner.gdprLink
            if (thisTherapistGDPRID !== null) {
                return `${baseURL}?i=${thisTherapistGDPRID}&b=${basisType?.name}`
            }
        }
        return baseURL
    }

    const buildLabel = () => {
        const handelsBetingelserLink = isCompanyBooking
            ? 'https://www.raskrask.dk/handelsbetingelser-erhverv/'
            : 'https://www.raskrask.dk/handelsbetingelser/'
        const privacyPolicyLink = getGDPRLink()
        return (
            <>
                {t('i.accept')}{' '}
                <Link href={handelsBetingelserLink} target="_blank">
                    {' '}
                    {t('common:termsoftrade')}
                </Link>{' '}
                &{' '}
                <Link href={privacyPolicyLink} target="_blank">
                    {t('common:privacypolicy')}
                </Link>
            </>
        )
    }

    return (
        <InputGroup
            checked={isAccepted}
            data-cy="policyCheckbox"
            error={(!isAccepted && showError) || (submitClickedWithMissingDetails && !isAccepted)}
            helperText={t('details.form.policy.error')}
            label={buildLabel()}
            labelPlacement="end"
            onBlur={() => setShowError(true)}
            onChange={() => setIsAccepted(!isAccepted)}
            type="checkbox"
        />
    )
}

export default TermsTemplate
